import React from 'react';
import { withRouter } from 'react-router-dom';

import {
    makeStyles,
    AppBar,
    Toolbar,
    Typography,
    IconButton
} from '@material-ui/core';

import { ArrowBack } from '@material-ui/icons';

const styles = makeStyles(theme => ({
    root: {
        top: 0,
        position: 'fixed',
        zIndex: 1,
        [theme.breakpoints.down('xs')]: {
            left: 0,
            width: '100%'
        },
        [theme.breakpoints.up('sm')]: {
            left: 230,
            width: `calc(100% - ${240}px)`
        }
    },
    titulo: {
        color: theme.palette.primary.contrastText
    },
    cabecalhoButton: {
        color: theme.palette.secondary.main,
        [theme.breakpoints.up('sm')]: {
            cursor: 'pointer'
        }
    }
}));

function Header(
    {
        titulo,
        link,
        history
    }
) {
    const classes = styles();

    const handleClick = () => {
        history.push(link);
    }

    return (
        <AppBar className={classes.root}>
            <Toolbar>
                {
                    link &&
                    <IconButton onClick={handleClick}
                        color="secondary">
                        <ArrowBack />
                    </IconButton>
                }
                <Typography variant="subtitle1"
                    classes={{ root: classes.titulo }}>
                    {titulo}
                </Typography>
            </Toolbar>
        </AppBar>
    );
}

export default withRouter(Header);